import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class CostCenterService extends CrudService {
  constructor() {
    super('costCenters')
  }

  fetchCostCenterUsers = async () => {
    const response = await axios.get(`${this.resource}/users`)
    return response.data
  }

  uploadCostCenter = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }
  uploadUserInCostCenter = async (file) => {
    const form = new FormData()
    form.append('file', file)
    const response = await axios.post(`${this.resource}/uploadUser`, form)

    return response.data
  }
}

export default CostCenterService
